<template>
    <v-container>
        <v-layout>
            <v-flex>
                <h2 class="hidden-sm-and-down">{{ txc.page_title }}</h2>
                <h4 class="mt-3">{{txc.communication_privacy_header}}</h4>
                <v-card flat class="mt-3">
                    <v-card-text>
                        <section>
                            <div v-if="marketLoggedIn == 'JP' || isDistributor" class="field-label">
                                {{ txc.upline_description }}
                            </div>
                            <div v-else class="field-label">{{ txc.retail_privacy_label }}</div>
                            <div class="field-value mb-4">
                                {{ getPrivacy === 2 ? sharedStrings.generic.no : sharedStrings.generic.yes }} 
                                ({{ getPrivacy === 0 ? txc.full_info_label : (getPrivacy === 1 ? txc.name_only_label : txc.dont_share_info) }})
                            </div>

                            <div v-if="marketLoggedIn !== 'JP' && isDistributor && false" class="field-label">
                                {{ txc.sponsor_search }}
                            </div>
                            <div v-if="marketLoggedIn !== 'JP' && isDistributor && false" class="field-value mb-4">
                                {{ visibleInSponsorSearchLabel }}
                            </div>

                            <div class="field-edit">
                                <a href="#" @click.stop="privacyDialog = true">{{
                                    txc.edit_privacy_preferences
                                }}</a>
                            </div>
                            <edit-privacy-preference-dialog
                                v-if="privacyDialog"
                                @closeDialog="privacyDialog = false"
                            />
                        </section>
                        
                    </v-card-text>
                </v-card>
                <h4 class="mt-3" v-if="isMember || isRetailCustomer">{{txc.order_privacy_header}}</h4>

                <v-card flat class="mt-3" v-if="isMember || isRetailCustomer">
                    <v-card-text v-if="!noDataFromService">
                        <section>
                            <div class="field-label">
                                {{txc.order_privacy_desc}}
                            </div>

                            <div class="field-label">{{txc.sponsor_label}}</div>
                            <div class="field-value mb-4">
                                {{orderPrivacy.values.sponsor ? sharedStrings.generic.no : sharedStrings.generic.yes}}
                            </div>

                            <div class="field-label" v-if="isMember">
                                {{txc.group_label}}
                            </div>
                            <div class="field-value mb-4" v-if="isMember">
                                {{orderPrivacy.values.group ? sharedStrings.generic.no : sharedStrings.generic.yes}}
                            </div>
                            <div class="field-label" v-if="isMember">
                                {{txc.upline_rep_label}}
                            </div>
                            <div class="field-value mb-4" v-if="isMember">
                                {{orderPrivacy.values.upline ? sharedStrings.generic.no : sharedStrings.generic.yes}}
                            </div>
                            <div class="field-edit">
                                <a href="#" @click.stop="orderPrivacyDialog = true">{{
                                    txc.edit_privacy_preferences
                                }}</a>
                            </div>
                            <edit-order-privacy-preference-dialog
                                v-if="orderPrivacyDialog"
                                @closeDialog="orderPrivacyDialog = false"
                            />
                        </section>
                    </v-card-text>
                    <v-card-text v-else>
                        <section>
                            <div class="field-label">
                                V&amp;G service returned no data for order privacy preferences.
                            </div>
                        </section>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import EditPrivacyPreferenceDialog from './forms/EditPrivacyPreferenceDialog'
import EditOrderPrivacyPreferenceDialog from './forms/EditOrderPrivacyPreferenceDialog'
import { mapActions, mapGetters } from 'vuex'
import { ProfileService } from '@nuskin/ns-account'
import privacyHelper from '../helpers/components/privacy'
export default {
    components: { EditPrivacyPreferenceDialog, EditOrderPrivacyPreferenceDialog },
    data() {
        return {
            privacyDialog: false,
            orderPrivacyDialog: false,
            noDataFromService: false
        }
    },
    methods: {
        ...mapActions(['setPrivacy', 'setOrderPrivacy'])
    },
    computed: {
        ...mapGetters({
            marketLoggedIn: 'marketLoggedIn',
            fullScreenModals: 'mobileView',
            txc: 'translationsPrivacy',
            sharedStrings: 'sharedStrings',
            isDistributor: 'isDistributor',
            isRetailCustomer: 'isRetailCustomer',
            isMember: 'isMember',
            visibleInSponsorSearch: 'visibleInSponsorSearch',
            getPrivacy: 'getPrivacy',
            orderPrivacy: 'orderPrivacy'
        }),
        visibleInSponsorSearchLabel() {
            return this.visibleInSponsorSearch ? this.sharedStrings.generic.yes : this.sharedStrings.generic.no
        }
    },
    mounted() {
        privacyHelper.callPrivacy(this, ProfileService)
        if (this.isRetailCustomer || this.isMember) {
            privacyHelper.callOrderPrivacy(this, ProfileService)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}
</style>
